import React, { useRef, useLayoutEffect, useState } from "react";
import { Children, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import {
  Button,
  Collapse,
  Stack,
  Tabs,
  Typography,
  useTheme,
} from "@mui/material";
import Icon from "../../../../Icon/Icon";
import { TabContext, TabPanel } from "@mui/lab";
import { useAppContext } from "../../../../AppContext/AppContext";
import { useConstants } from "../Main/useConstants";
import { useTranslation } from "react-i18next";

const transition = "all 200ms linear";

// Tabs con cada seccion de la investigacion
const FolderSection = ({
  tabProps,
  index,
  childrenQty,
  activeFolder,
  handleChange,
}) => {
  const { key, name, icon, iconSelected, color } = tabProps;
  const isActive = activeFolder === key;

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isHovering, setIsHovering] = useState(false);
  const buttonRef = useRef(null);

  // Detecta el ancho de la ventana
  useEffect(() => {
    window.addEventListener("resize", () => setWindowWidth(window.innerWidth));
    return () => {
      window.removeEventListener("resize", () =>
        setWindowWidth(window.innerWidth)
      );
    };
  }, []);

  // Detecta si el boton esta en hover
  useEffect(() => {
    if (buttonRef.current) {
      const button = buttonRef.current;

      const checkHoverState = () => {
        const isHovered = button.matches(":hover");

        if (isHovered) {
          setIsHovering(true);
        } else {
          setIsHovering(false);
        }
      };

      // Event listeners para detectar hover
      const handleMouseEnter = () => {
        checkHoverState();
      };

      const handleMouseLeave = () => {
        checkHoverState();
      };

      button.addEventListener("mouseenter", handleMouseEnter);
      button.addEventListener("mouseleave", handleMouseLeave);

      const hoverInterval = setInterval(() => {
        checkHoverState();
      }, 1000);

      return () => {
        button.removeEventListener("mouseenter", handleMouseEnter);
        button.removeEventListener("mouseleave", handleMouseLeave);
        clearInterval(hoverInterval);
      };
    }
  }, []);

  const returnShowLabel = () => {
    if (windowWidth <= 1440) return false;
    if (isActive) return true;
    return false;
  };

  return (
    <Button
      key={key}
      ref={buttonRef}
      onClick={() => handleChange(key)}
      disableRipple
      sx={{
        "&": {
          padding: 0,
          marginRight: "-15px",
          fontSize: "14px",
          fontWeight: "bold",
          position: "relative",
          zIndex: isActive ? childrenQty - index + 2 : childrenQty - index,
          cursor: "pointer",
          height: isActive ? "45px" : "37px",
          transition,
        },
        display: "flex",
        alignItems: "flex-end",
        "&:hover": {
          backgroundColor: "transparent",
        },
      }}
    >
      <Box
        sx={{
          padding: isActive ? "10px 10px" : "10px 5px 10px 15px",
          height: isActive ? "45px" : "37px",
          display: "flex",
          border: `2px solid ${color}`,
          borderBottom: "none",
          borderRadius: "15px 3px 0 0",
          borderRight: "transparent",
          backgroundColor: isActive ? color : "#FFFFFF",
          alignItems: "center",
          transition,
        }}
      >
        <Icon
          name={isActive ? iconSelected : icon}
          color={isActive ? "#FFFFFF" : color}
          size={isActive ? 24 : 16}
          style={{ marginTop: !isActive ? 2 : 0 }}
        />
        <Collapse orientation="horizontal" in={isActive || isHovering}>
          <Typography
            fontWeight={600}
            fontSize={isActive ? "14px" : "12px"}
            textTransform="none"
            overflow="hidden"
            whiteSpace="nowrap"
            transition="all 0.25s linear"
            opacity={isActive ? 1 : 0}
            color={isActive ? "#FFFFFF" : color}
            marginLeft={isActive ? 1 : 0.5}
          >
            {name[0].toUpperCase() + name.slice(1)}
          </Typography>
        </Collapse>
      </Box>
      <Box
        sx={{
          position: "relative",
          height: isActive ? 45 : 37,
          backgroundColor: "transparent",
          border: "none",
          transition,
        }}
      >
        <Box // Tab
          sx={{
            position: "absolute",
            // top: 'px',
            width: "12px",
            left: "2px",
            height: "calc(100%)",
            // height: isActive ? '100%' : 'calc(100% - 2px)',
            backgroundColor: isActive ? color : "#FFFFFF",
            borderTop: `2px solid ${color}`,
            borderRight: `2px solid ${color}`,
            transform: "skewX(15deg)",
            borderTopRightRadius: "20px",
            zIndex: 2,
            // zIndex: isActive ? childrenQty - index + 2 : childrenQty - index,
            boxShadow: "2px 0px 2px 0px rgba(0, 0, 0, 0.2)",
            transition,
          }}
        />
        <Box // Triangle
          sx={{
            position: "absolute",
            // bottom: isActive ? '-1px' : '0px',
            top: isActive ? "1px" : "2px",
            width: "13px",
            left: "-1px",
            height: isActive ? "calc(100%)" : "calc(100% - 2px)",
            backgroundColor: isActive ? color : "#FFFFFF",
            zIndex: 2,
            // zIndex: isActive ? childrenQty - index + 2 : childrenQty - index,
            clipPath: "polygon(0 0, 50% 30%, 100% 100%, 0 100%);",
            transition,
          }}
        />
        <Box // Spacing
          sx={{
            position: "relative",
            width: "28px",
            backgroundColor: "transparent",
            border: "none",
          }}
        />
      </Box>
    </Button>
  );
};

// Tab que esta a la derecha de la investigacion
const TabFixed = ({ tabProps, activeFolder, setShowModalHireService }) => {
  const { key, name, icon, color } = tabProps;
  const isActive = activeFolder === key;

  return (
    <Button
      key={key}
      disableRipple
      sx={{
        "&": {
          padding: 0,
          fontSize: "14px",
          fontWeight: "bold",
          position: "relative",
          cursor: "pointer",
          height: isActive ? 45 : 37,
          transition,
        },
      }}
      onClick={() => setShowModalHireService(true)}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          // background: 'linear-gradient(180deg, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.15) 80%, rgba(255,255,255,0) 100%)',
          zIndex: 3,
        }}
      />
      <Box
        sx={{
          position: "relative",
          height: "100%",
          backgroundColor: "transparent",
          border: "none",
          transition,
        }}
      >
        <Box // Tab
          sx={{
            position: "absolute",
            // top: 'px',
            width: "12px",
            right: "2px",
            height: "100%",
            // height: isActive ? '100%' : 'calc(100% - 2px)',
            backgroundColor: tabProps.color,
            // backgroundColor: '#CECECE',
            borderTop: `2px solid ${color}`,
            borderLeft: `2px solid ${color}`,
            transform: "skewX(-15deg)",
            borderTopLeftRadius: "20px",
            zIndex: 2,
            // zIndex: isActive ? childrenQty - index + 2 : childrenQty - index,
            boxShadow: "-2px 0px 2px 0px rgba(0, 0, 0, 0.2)",
            transition,
          }}
        />
        <Box // Triangle
          sx={{
            position: "absolute",
            // bottom: isActive ? '-1px' : '0px',
            top: isActive ? "1px" : "2px",
            width: "13px",
            right: "-1px",
            height: isActive ? "calc(100%)" : "calc(100% - 2px)",
            backgroundColor: tabProps.color,
            zIndex: 2,
            // zIndex: isActive ? childrenQty - index + 2 : childrenQty - index,
            clipPath: "polygon(100% 0%, 100% 100%, 0% 100%, 50% 30%);",
            transition,
          }}
        />
        <Box // Spacing
          sx={{
            position: "relative",
            width: "28px",
            backgroundColor: "transparent",
            border: "none",
          }}
        />
      </Box>
      <Box
        sx={{
          padding: isActive ? "10px 10px" : "10px 15px 10px 5px",
          height: 37,
          display: "flex",
          maxWidth: "100%",
          border: `2px solid ${color}`,
          borderBottom: "none",
          borderRadius: "3px 15px 0 0",
          borderLeft: "transparent",
          backgroundColor: tabProps.color,
          transition,
        }}
      >
        <Icon
          name={icon}
          color={"#FFFFFF"}
          style={{ marginTop: 1 }}
          size={16}
        />
        <Typography
          fontWeight={600}
          fontSize="12px"
          // lineHeight={.8}
          marginLeft={0.8}
          sx={{
            whiteSpace: "nowrap",
            color: "#FFFFFF",
            transition,
          }}
        >
          {name}
        </Typography>
      </Box>
    </Button>
  );
};

// Oculta las tabs que no se deben mostrar dependiendo del tipo de investigacion y si esta cerrada
const hideTab = (tab, advance, closed, enums) => {
  const allowOnSimple = [
    enums.sections.researchFolder,
    enums.sections.caseEvaluation,
    enums.sections.locations,
    // "reportCauses",
    enums.sections.involveds,
    enums.sections.evidences,
    enums.sections.conclusion,
  ];

  // const allowOnClosed = [
  //   enums.sections.researchFolder,
  //   enums.sections.conclusion,
  // ];

  // Si la investigacion esta cerrada
  // if (closed) {
  //   return !allowOnClosed.includes(tab);
  // }

  // Si la investigacion no es avanzada y no esta en la lista de tabs permitidas
  if (!advance && !allowOnSimple.includes(tab)) {
    return <></>;
  }
};

export const InvestigationNavigation = ({
  activeFolder,
  advance,
  closed,
  hdlSelect,
  investigation,
  setShowModalHireService,
  children,
}) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme();

  const { enums } = useConstants();

  // Retorna el color de la seccion seleccionada
  const returnColorOfSelectedSection = useMemo(() => {
    let color = theme.palette.blueGray.main;

    Children.forEach(children, (child, index) => {
      if (child.props.tabProps.key === activeFolder) {
        color = child.props.tabProps.color;
      }
    });
    return color;
  }, [activeFolder, advance, closed]);

  return (
    <Box className="investigation-navigation" marginTop={2}>
      <Stack
        direction="row"
        flexWrap="nowrap"
        alignItems="end"
        justifyContent="space-between"
        height={45}
        zIndex={0}
      >
        <Stack
          direction="row"
          flexWrap="nowrap"
          alignItems="end"
          height={45}
          zIndex={0}
        >
          {Children.map(children, (child, index) => {
            if (hideTab(child.props.tabProps.key, advance, closed, enums))
              return <></>;
            return (
              <FolderSection
                tabProps={child.props.tabProps}
                index={index}
                childrenQty={Children.count(children)}
                activeFolder={activeFolder}
                handleChange={hdlSelect}
              />
            );
          })}
          {/* <TabSVGTest /> */}
        </Stack>
        {/* <TabFixed
          tabProps={{
            key: "fixed",
            name: t("sections.hire_service"),
            icon: "outline_search_eg",
            color: returnColorOfSelectedSection,
          }}
          activeFolder={activeFolder}
          handleChange={hdlSelect}
          setShowModalHireService={setShowModalHireService}
        /> */}
      </Stack>

      <TabContext value={activeFolder}>
        <Box
          sx={{
            border: `2px solid ${returnColorOfSelectedSection}`,
            borderRadius: "0 0 10px 10px",
            overflow: "hidden",
            transition,
          }}
        >
          {Children.map(children, (child) => {
            if (hideTab(child.props.tabProps.key, advance, closed, enums))
              return <></>;
            return (
              <TabPanel
                key={child.props.tabProps.key}
                value={child.props.tabProps.key}
                sx={{
                  padding: 0,
                }}
              >
                {child}
              </TabPanel>
            );
          })}
        </Box>
      </TabContext>
    </Box>
  );
};

// const TabSVG = ({
//   active = false,
//   hover = false,
//   color = "#00A7DF",
//   icon,
//   label = "",
//   height = 37,
//   iconSize = 20,
//   paddingX = 24, // Espacio a la izquierda y derecha
//   gap = 10, // Espacio entre icono y texto
// }) => {
//   const bgColor = active ? color : "#fff";
//   const borderColor = color;

//   return (
//     <svg height={37} viewBox={`0 -1 37 37`} style={{ display: "block" }}>
//       <path
//         d={`
//           M 0 0
//           Q 5 0, 9 10
//           L 20 36
//           L 0 36
//         `}
//         fill={bgColor}
//         stroke={borderColor}
//         strokeWidth="1.4"
//         vectorEffect="non-scaling-stroke"
//       />
//     </svg>
//   );
// };

// Puedes poner esto al final de InvestigationNavigation.jsx SOLO para pruebas
// const TabSVGTest = () => (
//   <div style={{ display: "flex", gap: 16, background: "#f5f5f5", padding: 32 }}>
//     {/* Tab activa */}
//     <TabSVG
//       active={true}
//       color="#00A7DF"
//       icon={<Icon name="outline_search_eg" />}
//       label="CARPETA DE INVESTIGACIÓN"
//     />
//     {/* Tab hover */}
//     <TabSVG
//       hover={true}
//       color="#00A7DF"
//       icon={<Icon name="outline_search_eg" />}
//       label="CARPETA DE INVESTIGACIÓN"
//     />
//     {/* Tab inactiva */}
//     <TabSVG
//       color="#00A7DF"
//       icon={<Icon name="outline_search_eg" />}
//       label="CARPETA DE INVESTIGACIÓN"
//     />
//     {/* Tab solo icono */}
//     <TabSVG color="#00A7DF" icon={<Icon name="outline_search_eg" />} />
//   </div>
// );
